import { SpBuilderNameInterface } from '../interfaces/sp-builder-name.interface';
import { ApiProperty } from '@nestjs/swagger';
import { Type } from 'class-transformer';
import { IsBoolean, IsUUID, MaxLength } from 'class-validator';
import { CommonEntityDto } from '../../../common/dto/common-entity.dto';
import { BuilderDto } from '../../../builder/dto/builder.dto';

export class SpBuilderNameDto
  extends CommonEntityDto
  implements SpBuilderNameInterface
{
  @ApiProperty({ required: true })
  @MaxLength(250, {
    message: 'The spName field is required and must not exceed 250 characters',
  })
  spName!: string;

  @ApiProperty({ type: 'string', name: 'Sp Name Id' })
  spNameId!: string;

  @ApiProperty({ required: true })
  @IsUUID()
  builderId!: string;

  @ApiProperty({ type: () => BuilderDto })
  @Type(() => BuilderDto)
  builder?: BuilderDto;

  @ApiProperty({
    type: 'boolean',
    default: true,
    title: 'Active?',
    description: 'True if SuppyPro builder name is active',
  })
  @IsBoolean()
  active!: boolean;
}
